import SponsorsFooter from "../../screens/home/components/matchGames/components/matchGame/components/SponsorsFoooter";
import { secureUrl } from "../../utils/sortArray/secureUrl"
import './index.css';

const StadisticTable = ({title, targetName, players = [], tournament, target})=>{
    return(
<div className="container-striker-table">
        <div className="subcontainer-striker-table" >
                            <SponsorsFooter />

        <div>
            <div className="container-striker-header" >
                <div>
                    <h3 >{title}</h3>
                </div>
                <div className="container-striker-header-tournament" >
                <img src={secureUrl(tournament?.imgPicture)}  />
                <h3 >{tournament?.name}</h3>
                </div>

            </div>

        </div>
        <div style={{overflow:'scroll', height:'75vh'}}>
        <table style={{width:'100%'}}>
        <thead>
        <tr>
          <th style={{width:'15%', color:'#e7af57'}}>Nº</th>
          <th style={{width:'35%', color:'#e7af57', textAlign:'start'}} >Nombre</th>
          <th style={{width:'35%', color:'#e7af57',textAlign:'start'}} >Equipo</th>
          <th style={{width:'15%', color:'#e7af57'}} >{targetName}</th>
        </tr>
      </thead>
      <tbody  >

{
    players?.map((player, index)=>(
        <tr  key={`${player?._id}`}>
        <td style={{width:'15%', textAlign:'center', color:'white',borderBottom:'1px solid #e7af57' }}>{index + 1}</td>
        <td className="container-tbody-striker-td" style={{width:'35%',color:'white', borderBottom:'1px solid #e7af57'}}> <div style={{display:'flex', alignItems:'center'}} ><img alt={`${player?._id}`} src={player?.img || secureUrl(player?.equipo?.pictureTeam)} /> <h3>{player?.name}</h3></div> </td>
        <td className="container-tbody-striker-td-team"  style={{width:'35%', color:'white',borderBottom:'1px solid #e7af57' }}> {player?.equipo?.name} </td>
        <td className="container-tbody-striker-td-goles" style={{width:'15%',textAlign:'center', color:'white',borderBottom:'1px solid #e7af57' }}><h2>{player?.[target]}</h2></td>
    </tr>

    ))
}
</tbody>
        </table>

        </div>



        </div>


    </div>
    )
}

export default StadisticTable